import { render, staticRenderFns } from "./VcitaDateRangeTitle.vue?vue&type=template&id=0cf86918&scoped=true"
import script from "./VcitaDateRangeTitle.vue?vue&type=script&lang=js"
export * from "./VcitaDateRangeTitle.vue?vue&type=script&lang=js"
import style0 from "./VcitaDateRangeTitle.vue?vue&type=style&index=0&id=0cf86918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf86918",
  null
  
)

export default component.exports